import {
  Box,
  Text,
  Spacer,
  useColorMode,
} from "@chakra-ui/react";
import SettingsMenu from "../common/SettingsMenu";
import Translate from "../../components/LanguageTranslation/Translate";
import BellWithBadge from "./BellWithBadge";

const BucketHeader = ({fetchTrips}) => {
  /* ---------- theme ---------- */
  const { colorMode } = useColorMode();

  /* ---------- UI ---------- */
  return (
    <>
      <Box
        flex="1"
        display="flex"
        flexDirection="column"
        pb={1}
        maxH="8vh"
        borderBottom="1px"
        borderColor="blackAlpha.200"
        overflowY="hidden"
      >
        <Box
          display="flex"
          alignItems="center"
          bg={colorMode === "dark" ? "gray.700" : "white"}
          width="100%"
          height="100%"
          p={4}
          pt={2}
          pb={2}
          boxSizing="border-box"
          overflowY="hidden"
        >
          <Text
            fontSize="md"
            fontWeight="bold"
            mt={2}
            mb={0}
            color={colorMode === "dark" ? "gray.200" : "blackAlpha.700"}
          >
            <Translate text="Bucket List" />
          </Text>

          <Spacer />

          {/* Bell + badge */}
          <BellWithBadge fetchTrips={fetchTrips}/>

          <SettingsMenu />
        </Box>
      </Box>
    </>
  );
};

export default BucketHeader;
